import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { setInitialRoutingState } from '../../routing/getUseRouting';

export interface RoutingState extends Record<string, Record<string, any>> {}

const initialState: RoutingState = setInitialRoutingState();

export const routingSlice = createSlice({
    name: 'routing',
    initialState,
    reducers: {
        setterRouting: (state, action: PayloadAction<RoutingState>) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setterRouting } = routingSlice.actions;

export const routingSliceReducer = routingSlice.reducer;
